export default __webpack_public_path__ + "static/bg-overview-69c0332c40be93de4d4ee9e46318bcb5.png";